import React from 'react';
import { FormProvider } from 'react-hook-form';
import PropTypes from 'prop-types';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer';
import DisplaySelectedOffers from '@@viewCommonComponents/displayer/DisplaySelectedOffers';
import DisplayErrorMessage from '@@viewCommonComponents/displayer/DisplayErrorMessage';
import useSouscriptionPricingForm from '../hooks/useSouscriptionPricingForm';
import { Icon, PageSubtitle, PageTitle } from '@fasstech/middle-design-system';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';

const SouscriptionPricingForm = ({ project, getMiddleText }) => {
  const {
    form,
    onSubmit,
    $onPrevClick,
    displayError,
    onSelect,
    selectedModuleCode,
    packs
  } = useSouscriptionPricingForm({
    project
  });

  const { handleSubmit } = form;

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <PageLayout className="overflow-x-hidden">
          <Icon name={'circlePickAProduct'} size={70} />
          <PageTitle>{getMiddleText('CHOIX_PRODUIT_VIEW_TITLE')}</PageTitle>
          <PageSubtitle>{getMiddleText('CHOIX_PRODUIT_VIEW_DESCRIPTION')}</PageSubtitle>
          <DisplaySelectedOffers
            packs={packs}
            enableSelection={true}
            onSelect={onSelect}
            isViewModeCustomer={true}
            selectedModuleCode={selectedModuleCode}
            displayQuoteTable={false}
          />
        </PageLayout>

        <div className={'my-4'}>
          {displayError && (
            <DisplayErrorMessage
              text={'Veuillez saisir au moins une offre pour poursuivre le parcours'}
            />
          )}

          <ButtonContainer
            $onPreviousButtonClick={$onPrevClick}
            nextButtonLabel={getMiddleText('GENERAL_COMMON_TEXTS_SUBSCRIBE_BUTTON_LABEL')}
            displayResumeButton
            errorTooltipMessage={getMiddleText(
              'GENERAL_COMMON_TEXTS_TAB_ACTION_ERROR_WARNING_DESCRIPTION'
            )}
            getMiddleText={getMiddleText}
          />
        </div>
      </form>
    </FormProvider>
  );
};

SouscriptionPricingForm.propTypes = {
  processHandlers: PropTypes.object
};

export default SouscriptionPricingForm;
